import { Injectable } from '@angular/core';
import { driver, type Config, type DriveStep } from 'driver.js';

@Injectable({ providedIn: 'root' })
export class HostedSummaryTourService {
  start(): void {
    const steps: DriveStep[] = [
      {
        element: '#tour-hs-header',
        popover: {
          title: 'Hosted Summary',
          description:
            'This screen shows hosted-user totals broken down by site, scope, and service type for one or more NS domains.',
          side: 'bottom',
          align: 'start',
        },
      },
      {
        element: '#tour-hs-domain-selector',
        popover: {
          title: 'Domain Selector',
          description:
            'Select one or more domains and click <strong>Get summaries</strong> to fetch hosted-user data from NetSapiens. Once loaded, the panel collapses and results appear below.',
          side: 'bottom',
          align: 'start',
        },
      },
      {
        element: '#tour-hs-results',
        popover: {
          title: 'Per-Domain Results',
          description:
            'Each domain gets its own panel. The top rows show totals by service type; the table below breaks them down by site and scope. Use search, field filters, and column toggles to focus on specific data. Download all results as CSV with the blue button.',
          side: 'top',
          align: 'start',
        },
      },
    ];

    const config: Config = {
      showProgress: true,
      nextBtnText: 'Next',
      prevBtnText: 'Back',
      doneBtnText: 'Done',
      progressText: '{{current}} of {{total}}',
      steps,
    };

    driver(config).drive();
  }
}
